import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { getUser } from "../lib/auth";
import { Bookmark, Clock } from "lucide-react";

export default function Bookmarks() {
  const navigate = useNavigate();
  const user = getUser();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      navigate("/login");
      return;
    }
    api.get("/bookmarks").then((r) => {
      setItems(r.data);
      setLoading(false);
    }).catch(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
      <div className="mb-8">
        <div className="chip chip-cyan mb-3"><Bookmark className="w-3 h-3" /> Koleksi Saya</div>
        <h1 className="font-heading text-4xl md:text-5xl font-black">Artikel Tersimpan</h1>
      </div>

      {loading ? (
        <div className="text-slate-500 text-center py-20">Memuat...</div>
      ) : items.length === 0 ? (
        <div className="text-slate-500 text-center py-20" data-testid="bookmarks-empty">
          Belum ada bookmark. Simpan artikel favorit dari halaman berita!
          <div className="mt-4"><Link to="/articles" className="btn-primary inline-flex">Jelajahi Berita</Link></div>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((a) => (
            <Link key={a.id} to={`/articles/${a.slug}`} className="card overflow-hidden flex flex-col group" data-testid={`bookmark-${a.id}`}>
              {a.image_url && (
                <div className="h-44 overflow-hidden">
                  <img src={a.image_url} alt="" className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
                </div>
              )}
              <div className="p-5 flex-1 flex flex-col">
                <span className="chip chip-cyan self-start mb-3">{a.category}</span>
                <h3 className="font-heading text-lg font-bold leading-snug line-clamp-2">{a.title}</h3>
                <p className="text-sm text-slate-400 mt-2 line-clamp-2 flex-1">{a.excerpt}</p>
                <div className="mt-4 flex items-center gap-2 text-[10px] font-mono uppercase tracking-widest text-slate-500">
                  <Clock className="w-3 h-3" /> {a.reading_time} min
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
